import React from 'react';
import './Footer.css';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaWhatsapp, FaLinkedin, FaInstagram } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { label: 'Beranda', href: '#home' },
    { label: 'Tentang', href: '#about' },
    { label: 'Fitur', href: '#solutions' },
    { label: 'Success Stories', href: '#projects' },
    { label: 'Kontak', href: '#contact' }
  ];

  const solutions = [
    'Invoice Management',
    'Subscription Billing',
    'Payment Gateway',
    'Customer Management',
    'Reporting & Analytics',
    'Multi-currency'
  ];

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-about">
            <h3>ORION BILLING</h3>
            <p className="footer-tagline">Smart Billing System</p>
            <p className="footer-description">
              Orion Billing adalah solusi billing modern untuk mengelola invoice, subscription, dan pembayaran. 
              Hemat waktu, tingkatkan cash flow, dan fokus pada pertumbuhan bisnis Anda.
            </p>
            <div className="footer-social">
              <a href="https://wa.me/6281234567890" target="_blank" rel="noopener noreferrer" className="footer-social-icon"><FaWhatsapp /></a>
              <a href="https://www.linkedin.com/company/cvorion" target="_blank" rel="noopener noreferrer" className="footer-social-icon"><FaLinkedin /></a>
              <a href="https://www.instagram.com/cvorion" target="_blank" rel="noopener noreferrer" className="footer-social-icon"><FaInstagram /></a>
            </div>
          </div>

          <div className="footer-links">
            <h4>Quick Links</h4>
            <ul>
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <a href={link.href}>{link.label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-links">
            <h4>Solusi Kami</h4>
            <ul>
              {solutions.map((solution, index) => (
                <li key={index}>
                  <a href="#solutions">{solution}</a>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-contact">
            <h4>Kontak</h4>
            <div className="footer-contact-item">
              <FaPhone />
              <span>+62 812-9721-8055</span>
            </div>
            <div className="footer-contact-item">
              <FaEnvelope />
              <span>sales@orionbilling.com</span>
            </div>
            <div className="footer-contact-item">
              <FaMapMarkerAlt />
              <span>Batam, Indonesia</span>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} Orion Billing System. All rights reserved.</p>
          <p>www.cvorion.com</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
